import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { map, Observable, of } from 'rxjs'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { CategoriesEntity, CategoriesResponse } from './categories.models'
import { environment } from 'apps/gb-front/src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class CategoriesApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  /**
   * Get the auction's Categories
   * @returns an observable emitting an array of the auction's categories
   */

  getCategories(urlName: string | undefined, offset: number): Observable<CategoriesResponse> {
    const params = new HttpParams({
      fromObject: { limit: environment.categoriesPageSize, offset },
    })
    const url = `auctions/${urlName}/categories/`

    return this.get<CategoriesResponse>(url, {
      params: params,
      withCredentials: false,
    })
  }

  /**
   * Resyncs a category by its uuid
   */

  syncCategory(urlName: string, uuid: string | undefined): Observable<CategoriesEntity> {
    try {
      return this.get<CategoriesEntity>(`auctions/${urlName}/categories/${uuid}/`, { withCredentials: false }).pipe(
        map((response) => response),
      )
    } catch (error) {
      return of()
    }
  }
}
